module.exports = __webpack_public_path__ + "img/file-earmark-word.19917284.svg";